import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function DownloadIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-download-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40 28.46v7.69c0 .64-.22 1.19-.67 1.64-.45.45-.99.67-1.63.67H2.31c-.64 0-1.19-.23-1.63-.67s-.68-1-.68-1.64v-7.69c0-.64.22-1.18.67-1.63.45-.45.99-.67 1.63-.67h11.18l3.25 3.27c.93.9 2.02 1.35 3.27 1.35s2.34-.45 3.27-1.35l3.27-3.27h11.15c.64 0 1.19.22 1.63.67.46.45.68.99.68 1.63zm-7.81-13.68c.27.66.16 1.22-.34 1.68L21.08 27.24c-.29.3-.65.46-1.08.46s-.79-.15-1.08-.46L8.15 16.47c-.5-.46-.61-1.03-.34-1.68.27-.63.75-.94 1.42-.94h6.15V3.08c0-.42.15-.78.46-1.08.3-.3.67-.46 1.08-.46h6.15c.42 0 .78.15 1.08.46.3.3.46.67.46 1.08v10.77h6.15c.68 0 1.16.31 1.43.93zm-1.88 20.15c.3-.3.46-.67.46-1.08 0-.42-.15-.78-.46-1.08-.3-.3-.67-.45-1.08-.45s-.78.15-1.08.45c-.3.3-.46.67-.46 1.08 0 .42.15.78.46 1.08.3.3.66.46 1.08.46s.78-.16 1.08-.46zm6.16 0c.3-.3.46-.67.46-1.08 0-.42-.15-.78-.46-1.08-.3-.3-.67-.45-1.08-.45-.42 0-.78.15-1.08.45-.3.3-.46.67-.46 1.08 0 .42.15.78.46 1.08.3.3.66.46 1.08.46.41 0 .77-.16 1.08-.46z"
  })));
}